// LoadingMessage.js
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './LoadingMessage.css'; // Import CSS file

const LoadingMessage = ({ message }) => {
    return (
        <div className="loading-message-container">
            <CircularProgress />
            <span className="loading-message-text">{message}</span>
        </div>
    );
};

export default LoadingMessage;
